import { ProjectFilesPopoverLocalDraft } from './ProjectFilesPopoverLocalDraft';
import { ProjectFilesPopoverServer } from './ProjectFilesPopoverServer';
import { isLocalDraftFilesProps, type ProjectFilesPopoverProps } from './ProjectFilesPopover.types';

import './ProjectFilesPopover.css';

export {
  PROJECT_FILES_MAX_BYTES,
  PROJECT_FILES_MAX_FILENAME_LENGTH,
} from './projectFilesPopoverConstants';

export type {
  ProjectFileLinkSelectionProps,
  ProjectFilesLocalDraft,
  ProjectFilesPopoverServerProps,
  ProjectFilesPopoverLocalDraftProps,
  ProjectFilesPopoverProps,
} from './ProjectFilesPopover.types';

export function ProjectFilesPopover(props: ProjectFilesPopoverProps) {
  if (isLocalDraftFilesProps(props)) {
    return (
      <ProjectFilesPopoverLocalDraft
        open={props.open}
        onClose={props.onClose}
        anchorEl={props.anchorEl}
        localDraft={props.localDraft}
      />
    );
  }
  return (
    <ProjectFilesPopoverServer
      open={props.open}
      onClose={props.onClose}
      anchorEl={props.anchorEl}
      project={props.project}
      fileLinkSelection={props.fileLinkSelection}
    />
  );
}
